import { useEffect, useState, useRef } from 'react';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './CollapsibleForm.module.css';

const CollapsibleForm = ({
  children,
  iconDesktop,
  iconMobile,
  title,
  text,
  contentVisible,
  toggleForm,
  dataCy,
}) => {
  const collapsibleFormRef = useRef(null);
  const [wasOpened, setWasOpened] = useState(false);

  useEffect(() => {
    if (wasOpened) {
      const element = collapsibleFormRef.current;
      const yOffset = $('.top-banner').length ? -200 : -100;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, [contentVisible]);

  const setWasOpenedAndToggleForm = () => {
    if (!wasOpened) {
      setWasOpened(true);
    }
    toggleForm();
  };

  return (
    <div
      className="collapsible-form"
      ref={collapsibleFormRef}
      data-testid={dataCy ? `collapsible-form-${dataCy}` : ''}
    >
      <div className="top-section" onClick={() => setWasOpenedAndToggleForm()}>
        <div className="form-icon">
          <img
            className={styles['hr-desktop']}
            src={iconDesktop ? iconDesktop : iconMobile}
            alt="Form icon"
          ></img>
          <img
            className={styles['hr-mobile']}
            src={iconMobile ? iconMobile : iconDesktop}
            alt="Form icon"
          ></img>
        </div>
        <div className="form-summary">
          <Heading testid={`${dataCy}-title`} variant="H5">
            <div className="form-title">
              {title}
              <span className="edit-button">{contentVisible ? '-' : '+'}</span>
            </div>
          </Heading>

          <div
            className="form-view"
            data-testid={dataCy ? `collapsible-form-view-${dataCy}` : ''}
          >
            <Paragraph className={styles.subtitle}>{text}</Paragraph>
          </div>
        </div>
      </div>
      <div
        className="form-content"
        data-testid={dataCy ? `collapsible-form-content-${dataCy}` : ''}
        style={{ display: contentVisible ? 'block' : 'none' }}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsibleForm;
